import { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@/store";
import { SubAccountListItemDto } from "@/models";

export interface CurrencyGroup {
  currency: string;
  subAccounts: SubAccountListItemDto[];
}

// Groups the already-fetched sub-account list (GET .../all/, which already
// carries crypto_currency per row) by currency, for the Screens 2/3 sidebar.
// No new backend call - purely a client-side grouping of existing state.
export function useSubAccountsByCurrency(): CurrencyGroup[] {
  const subAccounts = useSelector(
    (state: RootState) => state.subAccount.subAccounts,
  ) as SubAccountListItemDto[];

  return useMemo(() => {
    const groups = new Map<string, SubAccountListItemDto[]>();
    for (const subAccount of subAccounts) {
      const currency = subAccount.crypto_currency;
      if (!currency) {
        continue;
      }
      if (!groups.has(currency)) {
        groups.set(currency, []);
      }
      groups.get(currency)!.push(subAccount);
    }
    return Array.from(groups.entries())
      .map(([currency, accounts]) => ({ currency, subAccounts: accounts }))
      .sort((a, b) => a.currency.localeCompare(b.currency));
  }, [subAccounts]);
}
